'use client';
import { Home } from '@/flat-pages/home';
function GamesPage() {
  return <Home isGames={true} />;
}

export default GamesPage;
